import { helper } from "@ember/component/helper";
import { isHTMLSafe } from "@ember/template";

function titleizeLib(string = "") {
  if (typeof string !== "string") {
    throw new TypeError(`Expected a string, got a ${typeof string}`);
  }

  return string.toLowerCase().replace(/(?:^|\s|-|\/)\S/g, function (m) {
    return m.toUpperCase();
  });
}

export function createStringHelperFunction(stringFunction) {
  return function ([string]) {
    if (isHTMLSafe(string)) {
      // @ts-expect-error This code has been copied from the legacy ember-cli-string-helpers, let's leave it this way
      string = string.string;
    }

    string = string || "";
    return stringFunction(string);
  };
}

const titleize = createStringHelperFunction(titleizeLib);
export default helper(titleize);
